// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"65":"portal","283":"changelog","594":"about","966":"login"}[chunkId] || chunkId) + "." + {"65":"6d6fb6c5","114":"0a863034","283":"57018d30","594":"c7ab750a","966":"46a1ca15"}[chunkId] + ".js";
};